// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__J38TY","overflowing":"ReadFullNote_overflowing__1U2Rb"};